import React, { useEffect } from 'react'
import Breadcrumb from '../component/Breadcrumb'
import Footer from '../component/Footer'
import { Link } from 'react-router-dom'
import { TbPointFilled } from 'react-icons/tb'
import VousImages from '../assets/VousImages.png'
import { Helmet } from 'react-helmet';
export default function PrivacyPolicy() {
    useEffect(() => {window.scrollTo(0, 0)}, [])
    return (
    <>
    <Helmet>
        <title>Politique de confidentialité – Busyplace</title>
        <meta name="description" content="Politique de confidentialité – Busyplace" />
    </Helmet>   
    <div className='w-full h-full bg-mainBg '>
        <div className='md:max-w-[1477px] relative w-full h-full m-auto py-6 md:py-14 px-4 sm:px-14'>
            <div className='flex items-center justify-start gap-4 '>
            <Breadcrumb Accueil="Accueil" page="Politique de confidentialité" />
            </div>
            <div className='max-w-[1277px] m-auto mt-8 md:mt-16 block'>
            <h1 className='text-xl sm:text-2xl md:text-3xl font-black text-primary'>Politique de confidentialité – Busyplace</h1>
            </div>
        </div>
    </div>
    <div className='md:max-w-[1477px] relative w-full h-full m-auto px-4 sm:px-14'>
        <div className='max-w-[1277px] m-auto block bg-white py-6 md:py-12'>
            
            
            
            
            

            <h2 className='font-extrabold text-lg sm:text-xl text-primary mt-12'>Dernière mise à jour : 14/01/2026</h2>
            <p>&nbsp;</p>
            <p>La présente politique de confidentialité décrit comment <strong>NEXTGEN – BUSYPLACE</strong> collecte et traite les données personnelles des utilisateurs du site <strong>busyplace.fr</strong>, dans le cadre de la publication d’annonces légales et judiciaires, ainsi que de l’aide aux formalités des entreprises.</p>
            <h3 className='font-bold text-lg sm:text-xl text-primary mt-12 mb-6'><strong>1. Responsable du traitement</strong></h3>
            <p>Le responsable du traitement est :</p>
            <p><strong>NEXTGEN – BUSYPLACE</strong></p>
            <p>128 rue de la Boétie, 75008 Paris – France</p>
            <p>RCS Paris 922 622 832</p>
            <p>Email : <strong>contact@busyplace.fr</strong></p>
            <p>&nbsp;</p>

            <p>&nbsp;</p>
            <h3 className='font-bold text-lg sm:text-xl text-primary mt-12 mb-6'><strong>2. Données personnelles collectées</strong></h3>
            <p>Selon les services utilisés, nous pouvons traiter notamment :</p>
            <p><strong>Données d’identification et de contact</strong></p>
            <ul>
                <li>Nom, prénom</li>
                <li>Adresse email</li>
                <li>Numéro de téléphone</li>
                <li>Adresse postale / adresse de facturation</li>
                <li>Informations liées à l’entreprise (dénomination, forme, siège, etc.)</li>
            </ul>
            <p><strong>Données liées à la commande et à la prestation</strong></p>
            <ul>
                <li>Contenu des annonces rédigées sur la plateforme</li>
                <li>Informations nécessaires à la publication et aux formalités</li>
                <li>Historique des commandes, factures, paiements</li>
            </ul>
            <p><strong>Données techniques et de navigation</strong></p>
            <ul>
                <li>Adresse IP</li>
                <li>Logs techniques (date/heure, pages consultées, actions réalisées)</li>
                <li>Données de sécurité (prévention fraude, abus, incidents)</li>
            </ul>
            <p>&nbsp;</p>
            <p><strong>Paiement</strong></p>
            <p>Les paiements par carte bancaire sont traités via <strong>Stripe</strong>.</p>
            <p>NEXTGEN – BUSYPLACE <strong>n’a jamais accès</strong> au numéro complet de carte bancaire.</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <h3 className='font-bold text-lg sm:text-xl text-primary mt-12 mb-6'><strong>3. Finalités (pourquoi nous traitons vos données)</strong></h3>
            <p>Nous traitons vos données personnelles uniquement lorsque cela est nécessaire pour :</p>
            <ol>
                <li><strong>Créer et gérer votre compte utilisateur</strong>
                (accès à l’espace client, gestion du profil, accès aux services)</li>
                <li><strong>Fournir nos services</strong></li>
            </ol>
            <ul>
                <li>rédaction et publication d’annonces légales et judiciaires</li>
                <li>assistance à la constitution de dossiers de formalités</li>
                <li>génération de documents selon les informations saisies</li>
            </ul>
            <ol start="3">
                <li><strong>Gérer les commandes, paiements et facturation</strong></li>
            </ol>
            <ul>
                <li>émission des factures</li>
                <li>suivi de paiement</li>
                <li>gestion des demandes liées aux transactions</li>
            </ul>
<ol start="4">
<li><strong>Assurer la relation client et le support</strong></li>
</ol>
<ul>
<li>réponse aux demandes via email/téléphone</li>
<li>gestion des réclamations et demandes d’assistance</li>
</ul>
<ol start="5">
<li><strong>Sécuriser la plateforme et prévenir les abus</strong></li>
</ol>
<ul>
<li>détection de fraude</li>
<li>prévention des usages non autorisés</li>
<li>journalisation (logs) et mesures de sécurité</li>
</ul>
<ol start="6">
<li><strong>Améliorer nos services et la performance du site</strong></li>
</ol>
<ul>
<li>statistiques d’usage</li>
<li>optimisation des parcours utilisateurs</li>
<li>amélioration des fonctionnalités</li>
</ul>
<ol start="7">
<li><strong>Respecter nos obligations légales et réglementaires</strong></li>
</ol>
<ul>
<li>obligations comptables et fiscales</li>
<li>conservation légale de documents</li>
<li>réponse aux autorités compétentes si requis</li>
</ul>
<p>&nbsp;</p>
<ol start="8">
<li><strong>Communications liées au service (transactionnelles)</strong></li>
</ol>
<ul>
<li>confirmation de commande</li>
<li>notifications importantes relatives au traitement d’un dossier</li>
</ul>
<p>&nbsp;</p>

<p>&nbsp;</p>
<h3 className='font-bold text-lg sm:text-xl text-primary mt-12 mb-6'><strong>4. Bases légales du traitement</strong></h3>
<p>Selon les cas, les traitements sont fondés sur :</p>
<ul>
<li><strong>L’exécution d’un contrat</strong> (CGV / fourniture du service)</li>
<li><strong>Le respect d’une obligation légale</strong> (comptabilité, conservation)</li>
<li><strong>L’intérêt légitime</strong> (sécurité, prévention fraude, amélioration)</li>
<li><strong>Le consentement</strong> (uniquement lorsque requis, ex. cookies marketing)</li>
</ul>
<p>&nbsp;</p>

<p>&nbsp;</p>
<h3 className='font-bold text-lg sm:text-xl text-primary mt-12 mb-6'><strong>5. Destinataires des données</strong></h3>
<p>Vos données peuvent être accessibles :</p>
<ul>
<li>aux équipes internes NEXTGEN – BUSYPLACE habilitées</li>
<li>à nos prestataires techniques (hébergement, maintenance, emailing)</li>
<li>à <strong>Stripe</strong> (paiement en ligne)</li>
<li>aux <strong>journaux habilités</strong> partenaires lorsque la publication nécessite une transmission</li>
<li>aux autorités administratives/judiciaires si obligation légale</li>
</ul>
<p>Nous ne vendons jamais vos données.</p>
<p>&nbsp;</p>

<h3 className='font-bold text-lg sm:text-xl text-primary mt-12 mb-6'><strong>6. Durées de conservation</strong></h3>
<p>Nous conservons vos données uniquement pendant la durée nécessaire aux finalités :</p>
<ul>
<li>Données de compte : pendant la durée du compte + durée légale applicable</li>
<li>Données de facturation : conservation conforme aux obligations comptables/fiscales</li>
<li>Logs techniques : durée limitée, proportionnée aux objectifs de sécurité</li>
</ul>
<p>&nbsp;</p>

<h3 className='font-bold text-lg sm:text-xl text-primary mt-12 mb-6'><strong>7. Sécurité</strong></h3>
<p>Nous mettons en œuvre des mesures techniques et organisationnelles destinées à protéger vos données contre l’accès non autorisé, la perte, l’altération ou la divulgation.</p>
<p>&nbsp;</p>

<p>&nbsp;</p>
<h3 className='font-bold text-lg sm:text-xl text-primary mt-12 mb-6'><strong>8. Vos droits</strong></h3>
<p>Conformément à la réglementation applicable, vous pouvez exercer :</p>
<ul>
<li>droit d’accès</li>
<li>droit de rectification</li>
<li>droit d’opposition (dans certains cas)</li>
<li>droit à l’effacement (dans certains cas)</li>
<li>droit à la limitation</li>
<li>droit à la portabilité (si applicable)</li>
</ul>
<p>Pour exercer vos droits : <strong>contact@busyplace.fr</strong></p>
<p>&nbsp;</p>

<p>&nbsp;</p>
<h3 className='font-bold text-lg sm:text-xl text-primary mt-12 mb-6'><strong>9. Cookies</strong></h3>
<p>Le site busyplace.fr peut utiliser des cookies nécessaires au fonctionnement du site, ainsi que des cookies de mesure d’audience selon votre paramétrage.</p>
<p>Une page dédiée peut être disponible : <strong>Politique cookies</strong>.</p>
<p>&nbsp;</p>

<p>&nbsp;</p>
<h3 className='font-bold text-lg sm:text-xl text-primary mt-12 mb-6'><strong>10. Contact</strong></h3>
<p>Pour toute question :</p>
<p>Email : <strong>contact@busyplace.fr</strong></p>
<p>Adresse : 128 rue de la Boétie, 75008 Paris</p>
        </div >
    </div>
    <Footer />
    </>
  )
}
